import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { PopupDataType, initialState } from './popupContentType'

const popupContentSlice = createSlice({
  name: 'popupContent',
  initialState,
  reducers: {
    updateListPopupAtStep3: (state, action: PayloadAction<{ data: PopupDataType[] }>) => {
      state.popupAtStep3 = action.payload.data
    },
  },
  extraReducers: () => {},
})

export const popupContentActionsCreator = popupContentSlice.actions

export default popupContentSlice
